import { c as _c } from "react/compiler-runtime";
import { PortableText, type PortableTextReactComponents } from 'next-sanity';
import React from 'react';
import { isString } from '@/util/type-guards';
import { classNames } from '@/util/utils';
import Spacer from './spacer';
import type { RichText } from '@/services/sanity/type-utils';
import styles from './text.module.css';
interface TextProps {
  className?: string;
  value: string | RichText;
  raw?: boolean;
  maxLines?: number;
}
const COMPONENTS: Partial<PortableTextReactComponents> = {
  types: {
    spacer: (value: unknown) => <Spacer value={value} />
  }
};
export function Text(t0) {
  const $ = _c(12);
  const {
    className,
    value,
    raw,
    maxLines: t1
  } = t0;
  const maxLines = t1 === undefined ? 0 : t1;
  const t2 = raw && styles.raw;
  const t3 = maxLines > 0 && styles.maxLines;
  let t4;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3) {
    t4 = classNames(className, styles.text, t2, t3);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== maxLines) {
    t5 = {
      "--custom-max-lines": maxLines
    };
    $[4] = maxLines;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== value) {
    t6 = isString(value) ? value : <PortableText value={value} components={COMPONENTS} />;
    $[6] = value;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t4} style={t5}>{t6}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}